// src/app/router/ui/ProtectedRoute.jsx
import React, { memo } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@app/providers';
import { PageLoader } from './PageLoader';

export const ProtectedRoute = memo(({ children, publicOnly = false }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  if (publicOnly && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!publicOnly && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
});
